import React from 'react';
import { Typography } from '@totalsoft/rocket-ui';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import { MY_FIRST_QUERY } from '../queries/MyQuery';
import { Grid } from '@mui/material';

const MyFeatureContainer = () => {
  const { data, loading } = useQueryWithErrorHandling(MY_FIRST_QUERY);

  if (loading) {
    return 'Loading data from GraphQL...';
  }
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant={'h6'}> {'This is the data returned by my query:'} </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>{`Id: ${data?.myFirstQuery?.id}`}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>{`ShortDescription: ${data?.myFirstQuery?.shortDescription}`}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>{`Text: ${data?.myFirstQuery?.text}`}</Typography>
      </Grid>
    </Grid>
  );
};

export default MyFeatureContainer;
